function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoCardBacks = function SvgLogoCardBacks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 132",
    height: 500,
    width: 500,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-164.70831)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 127.22029,132.89651 -23.49909,-2.78058 -8.230005,22.18571 -14.6502,-18.58253 -21.507162,9.86818 2.780577,-23.49909 -22.185713,-8.23001 18.582531,-14.650199 -9.868175,-21.507161 23.499088,2.780577 8.230007,-22.185713 14.6502,18.58253 21.507162,-9.868175 -2.78058,23.499089 22.18571,8.230006 -18.58253,14.650196 z",
    id: "path907",
    style: {
      opacity: 1,
      fill: "#fffff0",
      fillOpacity: 0,
      stroke: "#000000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 130.96207,154.54535 82.730492,141.46809 58.675158,185.27038 33.817298,141.91849 -14.165291,155.8817 -1.0880324,107.65012 -44.890326,83.594782 -1.5384302,58.736923 -15.501639,10.754334 32.729942,23.831592 56.785276,-19.970701 81.643136,23.381194 129.62572,9.4179858 116.54847,57.649566 l 43.80229,24.055335 -43.3519,24.857859 z",
    id: "path911",
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#000000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 142.72193,259.84954 -39.06402,-6.58146 -15.585406,36.41988 -22.968637,-32.27622 -36.773297,14.7322 6.581459,-39.06402 -36.419885,-15.58541 32.276226,-22.96864 -14.732199,-36.7733 39.064018,6.58146 15.585409,-36.41988 22.968638,32.27622 36.773294,-14.73219 -6.58146,39.06401 36.41989,15.58541 -32.27623,22.96864 z",
    id: "path913",
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 0,
      stroke: "#000000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2594",
    transform: "rotate(45.378168,52.878119,116.69841)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#0000ff"
    },
    transform: "rotate(31.684343,124.67837,159.95076)",
    id: "g6446"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000b66",
      strokeOpacity: 0.88888891
    },
    transform: "translate(98.340146,57.466144)",
    id: "g6547"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6594"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g2582",
    transform: "rotate(-45.378168,57.004478,113.09571)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect2572",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect2574",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6310",
    transform: "translate(1.5118718,-0.00997892)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g2588"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect2584",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect2586",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect2590",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect2592",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6322",
    transform: "rotate(45.251809,54.99012,114.61587)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6316"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6312",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6314",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6318",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6320",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    transform: "rotate(90.587588,55.539572,115.89906)",
    id: "g6334"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6328"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6324",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6326",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6330",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6332",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6346",
    transform: "rotate(134.45528,56.182183,115.71491)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6340"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6336",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6338",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6342",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6344",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    transform: "rotate(-174.43312,57.754095,114.31062)",
    id: "g6358"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6352"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6348",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6350",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6354",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6356",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6370",
    transform: "rotate(-134.40332,56.645207,113.32915)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6364"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6360",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6362",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6366",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6368",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    transform: "rotate(-92.206207,54.908226,113.18007)",
    id: "g6394"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeOpacity: 1
    },
    id: "g6388"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90.249103)",
    y: -56.421848,
    x: 70.424461,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6384",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6386",
    width: 1.6036172,
    height: 29.666916,
    x: 26.162884,
    y: 70.564491
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect6390",
    width: 1.6036172,
    height: 29.666916,
    x: 70.424461,
    y: -56.421848,
    transform: "rotate(90.249103)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 70.564491,
    x: 26.162884,
    height: 29.666916,
    width: 1.6036172,
    id: "rect6392",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000e7e",
      strokeWidth: 5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoCardBacks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-card-backs.2967113a.svg";
export { ForwardRef as ReactComponent };